import { Button, TableFooter, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "antd";
import { buildApiUrl } from "api/farmApi";
import axios from "axios";
import DrawerFilter from "components/DrawerFilter/DrawerFilter";
import FilterIcon from "components/icons/FilterIcon";
import LoadingComponent from "components/loading/Loading";
import { BASE_URL, TOKEN } from "constants/config";
import {
  fetchFrequencyList,
  selectFilterFrequency,
  selectFrequencyList,
  selectLoading,
  setFilterFrequency,
} from "features/Admin/adminSlice";
import FileDownload from "js-file-download";
import moment from 'moment';
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ChartStatisticFrequency from "./ChartFrequency/ChartStatisticFrequency";

const useStyles = makeStyles({
  container: {
    maxHeight: 700,
  },
  table: {
    minWidth: 700,
    overflowX: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  tabs: {
    display: "flex",
  },
  tabItem: {
    padding: 8,
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "#000",
    background: "#ECEDF2",
    marginRight: 4,
    minWidth: 120,
    cursor: "pointer",
  },
  active: {
    background: "#4350B0",
    color: "#fff",
  },
  stickyCol: {
    position: "sticky",
    left: 0,
    fontWeight: "bold",
    minWidth: 250,
    background: "#fff",
  },
  filter: {
    display: "flex",
    alignItems: "center",
    gap: "0px 12px",
  },
  filterIcon: {
    cursor: "pointer",
  },
  btn_export: {
    background: "#F65C00",
    color: "#fff",
    borderRadius: 6,
    textTransform: "capitalize",
    "&:hover": {
      background: "#F65C00",
      opacity: 0.8,
    },
  },
  footer: {
    position: "sticky",
    bottom: 0,
    backgroundColor: "#fff",
    zIndex: 1000,
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eaedf4",
    color: theme.palette.common.black,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    minWidth: 125,
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  footer: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
    color: theme.palette.common.black,
  },
}))(TableCell);

const dates = [
  "Tháng 1",
  "Tháng 2",
  "Tháng 3",
  "Tháng 4",
  "Tháng 5",
  "Tháng 6",
  "Tháng 7",
  "Tháng 8",
  "Tháng 9",
  "Tháng 10",
  "Tháng 11",
  "Tháng 12",
];

export default function Frquency() {
  const classes = useStyles();
  const tabs = [
    {
      name: "Thống kê",
      active: true,
    },
    {
      name: "Biểu đồ",
      active: false,
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs);
  const [openDrawerFilter, setOpenDrawerFilter] = useState(false);
  const listFrequency = useSelector(selectFrequencyList);
  const filter = useSelector(selectFilterFrequency);
  const loading = useSelector(selectLoading);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFrequencyList(filter));
  }, [dispatch, filter]);

  const handleChangeTab = (name) => {
    const mappingActive = activeTab.map((tab) => {
      if (tab.name == name) {
        return {
          ...tab,
          active: true,
        };
      }
      return {
        ...tab,
        active: false,
      };
    });
    setActiveTab(mappingActive);
  };
  const onFilterDate = (date, dateString) => {
    dispatch(
      setFilterFrequency({
        ...filter,
        year: Number(dateString),
      })
    );
  };

  const onExportFile = async () => {
    const token = localStorage.getItem(TOKEN);
    try {
      const res = await axios({
        method: "GET",
        url: buildApiUrl(`${BASE_URL}/statisic/repeatation/export/excel`,filter),
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "blob",
        },
        responseType: "arraybuffer",
      });
      if (res.data.responseDescription) {
        toast.error('Xuất file thất bại');
        return;
      }
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileDownload(blob, `report-repeatation-${new Date().getTime()}.xlsx`);
      toast.success('Xuất file thành công');
    } catch (error) {}
  };


  const onOpenFilterDrawer = () => {
    setOpenDrawerFilter(true);
  };

  const onFilter = (data) => {
    dispatch(
      setFilterFrequency({
        ...filter,
        ...data,
      })
    );
    setOpenDrawerFilter(false);
  };

  return (
    <div>
      <div className={classes.header}>
        <div className={classes.tabs}>
          {activeTab?.map((tab) => (
            <div
              onClick={() => handleChangeTab(tab.name)}
              key={tab.id}
              className={
                tab.active
                  ? `${classes.tabItem} ${classes.active}`
                  : classes.tabItem
              }
            >
              {tab.name}
            </div>
          ))}
        </div>

        <div className={classes.filter}>
          <div className={classes.filterIcon} onClick={onOpenFilterDrawer}>
            <FilterIcon></FilterIcon>
          </div>
          <DatePicker onChange={onFilterDate} picker="year" defaultValue={moment()} />
          <Button
            onClick={onExportFile}
            className={classes.btn_export}
            variant="contained"
            color="primary"
          >
            Xuất File
          </Button>
        </div>
      </div>

      {activeTab[0].active &&
        (loading ? (
          <LoadingComponent />
        ) : (
          <TableContainer component={Paper} className={classes.container}>
            <Table
              stickyHeader
              className={classes.table}
              aria-label="spanning table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    className={classes.stickyCol}
                    style={{ background: "#ECEDF2" }}
                  >
                    Tên trại
                  </StyledTableCell>
                  {dates.map((date, idx) => (
                    <StyledTableCell
                      key={idx}
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      {date}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {listFrequency.length > 0 ? (
                  listFrequency.slice(0, -2).map((row) => (
                    <TableRow key={row.farmName}>
                      <StyledTableCell
                        className={classes.stickyCol}
                        style={{
                          color:
                            row.farmName === "Tần suất trung bình"
                              ? "#4350B0"
                              : row.farmName === "Tổng số trại lặp"
                              ? "#F65C00"
                              : "#000",
                        }}
                      >
                        {row.farmName}
                      </StyledTableCell>
                      {row.repeatationCount.map((item) => (
                        <Fragment key={Math.random() * 10000}>
                          <StyledTableCell align="center">
                            {item.repeatationCount}
                          </StyledTableCell>
                        </Fragment>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      style={{ height: 200 }}
                      align="center"
                      colSpan={12}
                    >
                      <Typography variant="body1" align="center">
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                {listFrequency.slice(-2).map((row, idx) => (
                  <TableRow
                    key={row.farmName}
                    className={classes.footer}
                    style={{ bottom: idx === 0 ? "54px" : "0px" }}
                  >
                    <StyledTableCell
                      className={classes.stickyCol}
                      style={{
                        color:
                          row.farmName === "Tần suất trung bình"
                            ? "#4350B0"
                            : row.farmName === "Tổng số trại lặp"
                            ? "#F65C00"
                            : "#000",
                      }}
                    >
                      {row.farmName}
                    </StyledTableCell>
                    {row.repeatationCount.map((item) => (
                      <Fragment key={Math.random() * 10000}>
                        <StyledTableCell align="center">
                          {item.repeatationCount}
                        </StyledTableCell>
                      </Fragment>
                    ))}
                  </TableRow>
                ))}
              </TableFooter>
            </Table>
          </TableContainer>
        ))}
      {activeTab[1].active && <ChartStatisticFrequency listFrequency={listFrequency.slice(-2)}  />}
      {openDrawerFilter && (
        <DrawerFilter
          onClose={() => setOpenDrawerFilter(false)}
          open={openDrawerFilter}
          filter={filter}
          onSubmit={onFilter}
        />
      )}
    </div>
  );
}
